var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{attrs:{"entity-name":"EmployeeStatistics","model":_vm.model,"required-date-value":_vm.$parent.dateRange,"icon":"mdi-cards","only-display":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }